import React from 'react';
import cn from 'classnames';
import CloseButton from 'components/UI/CloseButton';
import { useTrans } from 'utils/localisation';
import { observer, pricingCalculator as store } from 'store';
import * as styles from './ModalHeader.module.scss';

function ModalHeader({ handleClose, lastStep }) {
  const t = useTrans(['pricingCalculator']);
  const { currentStep, prevStep } = store;
  const stepsCount = Array.from({ length: lastStep }, (_, i) => i + 1);

  const handleArrowClick = () => {
    if (currentStep === 1) {
      handleClose();
    } else {
      prevStep();
    }
  };

  return (
    <div className={styles.modalHeader}>
      <div className={styles.navigation}>
        <button className={styles.prevArrow} onClick={handleArrowClick} />
        <div className={styles.text}>{`${t('step')} ${currentStep} ${t('of')} ${lastStep}`}</div>
        <CloseButton className={styles.closeButton} onClose={handleClose} theme="dark" size="sm" />
      </div>
      <div className={styles.stepLines}>
        {stepsCount.map(step => (
          <div
            key={step}
            className={cn(styles.stepLine, step <= currentStep && styles.active)}
            style={{ width: `${100 / lastStep}%` }}
          ></div>
        ))}
      </div>
    </div>
  );
}

export default observer(ModalHeader);
